import './App.css';

import '@fontsource/rethink-sans/400.css';
import '@fontsource/rethink-sans/500.css';
import '@fontsource/rethink-sans/600.css';
import '@fontsource/rethink-sans/700.css';
import '@fontsource/rethink-sans/800.css';
import '@fontsource/dm-serif-display/400.css';
import {Grid} from "@mui/system";
import Pagina from "./Pagina/Pagina";
import {createContext, useEffect, useState} from "react";
import {guardarObjLocal} from "./Servicios/Local/guardarObjLocal";
import {guardarStringLocal} from "./Servicios/Local/guardarStringLocal";
import {obtenerColWheres} from "./Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {obtenerObjLocal} from "./Servicios/Local/obtenerObjLocal";
import {obtenerDoc} from "./Servicios/BD/obtenerDoc";
import {obtenerStringLocal} from "./Servicios/Local/obtenerStringLocal";
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {useAnuncio} from "./Modulo_Anuncio/Hooks/useAnuncio";
import Anuncio_Suscribite from "./Pagina/Anuncios/Anuncio_Suscribite";

export const contexApp = createContext()

function App() {

    const {data: dataSubCat, actualizarDataLocal: actSubCat} = useObtenerDataActualizada({clave: 'subcategorias'})
    const [actColeccion, setActColeccion] = useState({})
    const [configuraciones, setConfiguraciones] = useState({})


    const valoresProvider = {
        actColeccion,
        configuraciones,
        subCategorias: dataSubCat
    }

    const {Provider} = contexApp;

    const obtenerDatos = async () => {

        let doxFechaAct = await obtenerDoc('actualizaciones', 'fecha')
        let fecha = undefined

        if (doxFechaAct.res && doxFechaAct.data) {
            fecha = doxFechaAct.data.fecha
        }

        let fechaLocal = obtenerStringLocal({key: 'fecha'})

        if (!fechaLocal || !fecha || (fechaLocal < fecha)) {

            await actualizarColeccion(fecha)
            await actualizarConfiguraciones()

        } else {
            let colActual = obtenerObjLocal({key: 'colActual'})
            setActColeccion(colActual)
            let config = obtenerObjLocal({key: 'configuraciones'})
            setConfiguraciones(config)
        }


    }


    const actualizarColeccion = async (fecha) => {

        let w = [where('actual', '==', 'Si')]
        let doxCol = await obtenerColWheres({col: 'colecciones', wheres: w})

        if (doxCol.res && doxCol.data[0]) {
            guardarObjLocal({key: 'colActual', obj: doxCol.data[0]})
            guardarStringLocal({key: 'fecha', dato: fecha})
            setActColeccion(doxCol.data[0])
        }
    }

    const actualizarConfiguraciones = async () => {


        let doxCol = await obtenerDoc('configuraciones', 'generales')

        if (doxCol.res && doxCol.data) {
            guardarObjLocal({key: 'configuraciones', obj: doxCol.data})
            setConfiguraciones(doxCol.data)
        }
    }

    useEffect(() => {

        obtenerFechaAct('subCategorias').then((dox) => {
            let w = []
            actSubCat({fecha: dox, wheres: w}).then()
        })

        obtenerDatos()

    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{maxWidth: '100%', overflowX: 'hidden'}}
        >

            <Provider value={valoresProvider}>

                <Pagina/>


            </Provider>



        </Grid>
    );
}

export default App;
